export const projectsList = {
  label: 'Name Projects',

  price: 'Project price: 3.400 €',
  execution: 'Budget Execution: 324.166 €',
};
